module.exports = __webpack_public_path__ + "img/role06.2358c3c4.png";